var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},[_vm._l((_vm.slides),function(slide,index){return _c('home-carousel-component',{key:`item-${index}`,attrs:{"slide":slide,"current-slide":_vm.currentSlide,"index":index}})}),_c('home-text')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }